import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import {
  Button,
  Dropdown,
  Checkbox,
  Container,
  Segment,
  Dimmer,
  Loader,
  Menu,
  Icon,
} from 'semantic-ui-react';

import { getPageData } from '_utils';
import Pagination from '_views/pagination';
import { PluralSearch as LicensesSearch } from '_forms/licenseSearch';
import License from './license';

const LicensesPage = ({
  display,
  licensesPage,
  onRefreshList,
  onRefreshLicense,
  onRemoveLicense,
  onReactivateLicense,
  onModifyLicense,
  onAddSublicense,
  onRemoveSublicense,
  onRemoveLicenseMachine,
  onDeactivateLicenseUpgrade,
  setNavigation,
  onTermChange,
  onSelectionChange,
  onClearSuggestions,
}) => {
  const {
    items,
    request,
    total,
    navigation,
    pageNum,
    perPage,
    autocomplete
  } = getPageData([], licensesPage);

  const dropdownOptions = [
    {text: 'All', value: 'all', key: 'all', label: { color: 'grey', empty: true, circular: true }},
    {text: 'Only Claimed', value: 'claimed', key: 'claimed', label: { color: 'grey', empty: true, circular: true }},
    {text: 'Only Unclaimed', value: 'unclaimed', key: 'unclaimed', label: { color: 'grey', empty: true, circular: true }}
  ];

  const goToPage = ({ pageNum, perPage }) => {
    const nav = licensesPage.navigation || {};
    onRefreshList(R.merge(nav, { pageNum, perPage }));
  };

  const handleRefreshList = () => {
    const nav = licensesPage.navigation || {};
    onRefreshList(nav);
  };

  const handleFilterChange = (_, { value }) => {
    const nav = licensesPage.navigation || {};
    onRefreshList(R.merge(nav, { pageNum: 1, perPage: 20, ids: [], filter: value }));
  };

  const handleShowExpiredChange = (_, data) => {
    const nav = licensesPage.navigation || {};
    onRefreshList(R.merge(nav, { pageNum: 1, perPage: 20, ids: [], showExpired: data.checked }));
  };

  return (
    <Container textAlign='left' fluid style={display ? {} : { display: 'none' }} >
      <Menu icon='labeled' secondary size='small'>
        <Menu.Menu position='left'>
          <Menu.Item fitted header style={{ maxWidth: "100%" }}>
            <LicensesSearch
              autocomplete={autocomplete}
              onTermChange={onTermChange}
              onSelectionChange={onSelectionChange}
              onClearSuggestions={onClearSuggestions}
            />
          </Menu.Item>

          {licensesPage.navigation && licensesPage.navigation.ids ? (
            <Menu.Item>
              <Button.Group size='mini'>
                <Dropdown
                  icon="filter"
                  floating
                  labeled
                  button
                  options={dropdownOptions}
                  className="icon"
                  onChange={handleFilterChange}
                  value={navigation.filter}
                  text={(navigation.filter && navigation.filter.value && navigation.filter.value.text) || 'Filter'}
                />

                <Checkbox
                  onChange={handleShowExpiredChange}
                  as={Button}
                  label='show expired'
                  toggle
                />
              </Button.Group>
            </Menu.Item>
          ) : null}
        </Menu.Menu>

        <Menu.Menu position='right'>
          <Menu.Item name='refresh' onClick={handleRefreshList} >
            <Icon name='refresh' />
            Refresh
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Pagination
        goToPage={goToPage}
        pageNum={pageNum}
        perPage={perPage}
        total={total}
      />

      <Segment basic>
        <Dimmer inverted active={request.isLoading === true}>
          <Loader />
        </Dimmer>

        {items.map((u) => (
          <License
            key={u._id}
            setNavigation={setNavigation}
            onRemoveLicense={onRemoveLicense}
            onRefreshLicense={onRefreshLicense}
            onModifyLicense={onModifyLicense}
            onReactivateLicense={onReactivateLicense}
            onAddSublicense={onAddSublicense}
            onRemoveSublicense={onRemoveSublicense}
            onRemoveLicenseMachine={onRemoveLicenseMachine}
            onDeactivateLicenseUpgrade={onDeactivateLicenseUpgrade}
            license={u}
            isLoading={request.isLoading === u._id}
          />
        ))}
      </Segment>
    </Container>
  );
};

LicensesPage.propTypes = {
  display: PropTypes.bool.isRequired,
  licensesPage: PropTypes.object.isRequired,
  onRefreshList: PropTypes.func.isRequired,
  onRefreshLicense: PropTypes.func.isRequired,
  onRemoveLicense: PropTypes.func.isRequired,
  onReactivateLicense: PropTypes.func.isRequired,
  onModifyLicense: PropTypes.func.isRequired,
  onAddSublicense: PropTypes.func.isRequired,
  onRemoveSublicense: PropTypes.func.isRequired,
  onRemoveLicenseMachine: PropTypes.func.isRequired,
  onDeactivateLicenseUpgrade: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired,
  onTermChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onClearSuggestions: PropTypes.func.isRequired
};

export default LicensesPage;



// WEBPACK FOOTER //
// ./webAdmin/components/licenses/page.js